export default function calculateGaussianScore(
  value: number,
  optimalValue: number,
  variance: number
): number {
  const exponent = -((value - optimalValue) ** 2) / (2 * variance * variance);
  const score = Math.exp(exponent);
  return score;
}
